import QuizPage from '../../components/pages/QuizPage';
import themes from '../../themes';

export default function QuizSchwer() {
  return <QuizPage difficulty="quiz-schwers" theme={themes.quiz} />;
}